export default class ConversorDeData {
    static transformaDeMinutosParaData(tempoEmMinutos) {
        return new Date(new Date().getTime() + tempoEmMinutos * 60 * 1000);
    }
}